import { useAssistant } from '@services/AssistantProvider';
import { AssistantSidebarExpanded } from './AssistantSidebarExpanded';
import { AssistantSidebarCollapsed } from './AssistantSidebarCollapsed';
import styles from './AssistantSidebar.module.scss';

export const AssistantSidebar = () => {
	const { isOpen, setIsOpen } = useAssistant();

	return (
		<aside className={`${styles.assistantSidebar} ${isOpen ? styles.expanded : styles.collapsed}`} aria-label="Assistant">
			{isOpen ? (
				<AssistantSidebarExpanded onCollapse={() => setIsOpen(false)} />
			) : (
				<AssistantSidebarCollapsed onExpand={() => setIsOpen(true)} />
			)}
		</aside>
	);
};
